"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.h6 = exports.h5 = exports.h4 = exports.h3 = exports.h2 = exports.h1 = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _styledNormalize = _interopRequireDefault(require("styled-normalize"));

var _Constant = require("./Constant");

var _Constant2 = require("./Dashboard/Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n\n  html {\n    margin: 0;\n    padding: 0;\n    font-size: 62.5%;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  body {\n    margin: 0;\n    padding: 0;\n    min-width: 100%;\n    font-family: ", ";\n    background-color: ", ";\n\n    ", "\n\n    @media print, screen and (max-width: ", "px) {\n      text-size-adjust: 100%;\n    }\n  }\n\n  html, *, ::after, ::before {\n    box-sizing: border-box;\n  }\n\n  ", "\n\n  h1 {\n    ", "\n  }\n\n  h2 {\n    ", "\n  }\n\n  h3 {\n    ", "\n  }\n\n  h4 {\n    ", "\n  }\n\n  h5 {\n    ", "\n  }\n\n  h6 {\n    ", "\n  }\n\n  p, li, th, td {\n    line-height: 1.6;\n  }\n\n  p {\n    padding: 0;\n    margin: 0 0 15px;\n    font-size: 1.5rem;\n\n    + h3 {\n      margin-top: 30px;\n    }\n  }\n\n  strong {\n    font-weight: 600;\n  }\n\n  small {\n    font-weight: 400;\n  }\n\n  a {\n    ", "\n  }\n\n  input,\n  textarea,\n  select {\n    font-size: 1.5rem;\n    font-weight: 500;\n\n    @media print, screen and (min-width: ", "px) {\n      font-size: 1.6rem;\n    }\n  }\n\n  .center {\n    text-align: center;\n  }\n\n  // deprecated, use Text.Legal\n  .legal {\n    font-size: 1.2rem;\n    line-height: 1.66667;\n    margin: 30px 0;\n    color: ", ";\n  }\n\n  hr {\n    display: block;\n    height: 1px;\n    border: 0;\n    border-top: 1px solid ", ";\n    margin: 30px 0;\n    padding: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var bodySpecific = (0, _styledTheming.default)('flow', {
  onboarding: "\n    font-weight: 600;\n    color: ".concat(_Constant.Color.MEDIUM_GREY, ";\n  "),
  dashboard: "\n    font-size: 1.5rem;\n    font-weight: 400;\n    color: ".concat(_Constant2.Color.BLACK_SOUL, ";\n  ")
});
var commonHeaderStyles = (0, _styledTheming.default)('flow', {
  onboarding: "\n    h1, h2, h3, h4, h5, h6 {\n      font-family: ".concat(_Constant.Font.HEADER_FONT, ";\n      padding: 0;\n      margin: 0 0 8px;\n      color: ").concat(_Constant.Color.DARK_GREY, ";\n    }\n  "),
  dashboard: "\n    h1, h2, h3 {\n      font-family: ".concat(_Constant.Font.SECONDARY_HEADER_FONT, ";\n      padding: 0;\n      color: ").concat(_Constant2.Color.BLACK_SOUL, ";\n    }\n  ")
});
var h1 = (0, _styledTheming.default)('flow', {
  onboarding: "\n    font-size: 2.4rem;\n    font-weight: 400;\n    line-height: 1.416666;\n    margin-bottom: 20px;\n  ",
  dashboard: "\n    font-size: 2.2rem;\n    font-weight: 700;\n  "
});
exports.h1 = h1;
var h2 = (0, _styledTheming.default)('flow', {
  onboarding: "\n    font-size: 1.8rem;\n    font-weight: 500;\n    letter-spacing: 0.015em;\n    line-height: 1.5625;\n    margin-top: 10px;\n  ",
  dashboard: "\n    font-size: 1.8rem;\n    font-weight: 700;\n  "
});
exports.h2 = h2;
var h3 = (0, _styledTheming.default)('flow', {
  onboarding: "\n    font-size: 1.5rem;\n    font-weight: 400;\n    letter-spacing: 0.035em;\n    line-height: 1.47;\n    margin-top: 10px;\n  ",
  dashboard: "\n    font-size: 1.8rem;\n    font-weight: 700;\n  "
});
exports.h3 = h3;
var h4 = (0, _styledTheming.default)('flow', {
  onboarding: "\n    font-size: 1.3rem;\n    font-weight: 500;\n    letter-spacing: 0.035em;\n    line-height: 1.69;\n  ",
  dashboard: "\n    font-size: 1rem;\n    font-weight: 700;\n  "
});
exports.h4 = h4;
var h5 = (0, _styledTheming.default)('flow', {
  onboarding: "\n    font-size: 1.2rem;\n    font-weight: 500;\n    letter-spacing: 0.035em;\n    line-height: 1.42;\n  ",
  dashboard: "\n    font-size: 1.2rem;\n    font-weight: 700;\n  "
});
exports.h5 = h5;
var h6 = (0, _styledTheming.default)('flow', {
  onboarding: "\n    font-size: 1.1rem;\n    font-weight: 600;\n    letter-spacing: 0.035em;\n    line-height: 1.48;\n  ",
  dashboard: "\n    font-size: 1.1rem;\n    font-weight: 700;\n  "
});
exports.h6 = h6;
var aTag = (0, _styledTheming.default)('flow', {
  onboarding: "\n    cursor: pointer;\n    color: ".concat(_Constant.Color.MEDIUM_GREY, ";\n  "),
  dashboard: "\n    cursor: pointer;\n    color: ".concat(_Constant2.Color.BLACK_SOUL, ";\n  ")
});
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject(), function (props) {
  return props.normalize ? _styledNormalize.default : '';
}, _Constant.Font.PRIMARY_FONT, _Constant.Color.WHITE, bodySpecific, _Constant.Width.SM - 1, commonHeaderStyles, h1, h2, h3, h4, h5, h6, aTag, _Constant.Width.MD, _Constant.Color.MEDIUM_GREY, _Constant.Color.LINE_GREY);
GlobalStyle.defaultProps = {
  normalize: false
};
var _default = GlobalStyle;
exports.default = _default;